export const getPreviewUrl = (type: string, url: string) => {
  return `${process.env.REACT_APP_NEXT_CLIENT_URL}/${type}/${url}`;
};
